export default {
      id: "Quantity-of-visitors-usage",
      viewBox: "0 0 41 41",
      url: __webpack_public_path__ + "img/icons.cd84ca0f.svg#Quantity-of-visitors",
      toString: function () {
        return this.url;
      }
    }